<div>
    <app-user [inputForm]="data.form" [groupList]="data.groups"></app-user>
</div>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button [mat-dialog-close]="data">Save</button>
</mat-dialog-actions>